import { message } from "antd";
import React, { useState } from "react";
import { api } from "../../services/api";
import { Button } from "../Button";
import { ButtonDecline } from "../ButtonDecline";
import { Input } from "../Input";
import { Content } from "./styles";

interface Props {
  title: string;
  description?: string;
  confirm: () => void;
  cancel: () => void;
}
export function ExternalLogin({
  title,
  description,
  confirm,
  cancel,
  ...rest
}: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  function handleExternalLogin() {
    if ( !email || !password) {
      return setError("Preencha todos os dados marcados com *");
    }
    api.put('/users/externalconnection',  {
      email, password
    }).then((response)=>{
      message.success("Conexão externa alterada.");
      confirm()
    }).catch((e)=>{
      message.error(e.response.data.message);
      
    }).finally(()=> setLoading(false));
  }

  return (
    <Content
      visible={true}
      onCancel={cancel}
      closable={false}
      footer={[
        <div className="actions">
          <ButtonDecline title="Cancelar" onClick={cancel} disabled={loading} />
          <Button title="Confirmar" onClick={handleExternalLogin} loading={loading} />
        </div>,
      ]}
      width="800px"
      maskStyle={{
        background: "rgba(43, 43, 69, 0.8)",
      }}
    >
      <div className="title">{title}</div>
      <div className="description">{description}</div>

      <form>
        <div className="form-group">
          <span>*Email:</span>
          <Input
            placeholder="Digite o email"
            value={email}
            onChange={(ev) => setEmail(ev.currentTarget.value)}
          />
        </div>
        <div className="form-group">
          <span>*Senha:</span>
          <Input
            placeholder="Digite a senha"
            value={password}
            type="password"
            onChange={(ev) => setPassword(ev.currentTarget.value)}
          />
        </div>
      </form>
      <span className="error-message">{error}</span>
    </Content>
  );
}
